const state = {
  selectedContacts: [],
  totalSelectedContacts: 0
}

const getters = {
  contacts: state => state.selectedContacts,
  selectedCount: state => state.totalSelectedContacts
}

const mutations = {
  addContact(state, payload) {
    let foundContact = state.selectedContacts.findIndex(x=> x.contact_id === payload.contact_id)
    //console.log(`ContactIndexFound: ${foundContact}`)
    if (foundContact > -1) {
      //console.log('contact already added to queue');
      return;
    }
    state.selectedContacts.push({
      contact_id: payload.contact_id,
      org: payload.org_code,
      primary_organization: payload.primary_organization,
      aux_organization: payload.aux_organization,
      operation: payload.operation
    });

    state.totalSelectedContacts ++;

  },
  removeContact(state, payload) {
    // if list is empty bailout no need to remove anything
    if (state.selectedContacts.length == 0){
      return;
    }

    // find and remove at a specific index.
    state.selectedContacts.splice(state.selectedContacts.findIndex(x=>x.contact_id===payload.contact_id),1);

    // decrement the count
    state.totalSelectedContacts --;
  },
  clearContactSelection(state) {
    state.selectedContacts = [];
    state.totalSelectedContacts = 0;
  }

}

const actions = {
  addContactForUpdate({commit, state}, contactInfo) {
    commit('addContact', contactInfo);
  },
  removeContactFromUpdate({commit, state}, contactInfo) {
    commit('removeContact', contactInfo);
  },
  clearUpdateContacts({commit, state}) {
    commit('clearContactSelection',);
  },
  prepareAndSendUpdates({commit, state}) {

  }

}

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
}
